/**
 * @fileoverview added by tsickle
 * Generated from: util/http.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as serializers from './serializers';
import { HttpParams } from '@angular/common/http';
/**
 * @record
 */
function ParamsOpts() { }
if (false) {
    /** @type {?|undefined} */
    ParamsOpts.prototype.noTransform;
    /** @type {?|undefined} */
    ParamsOpts.prototype.params;
    /** @type {?|undefined} */
    ParamsOpts.prototype.paramsSerializer;
}
/**
 * @record
 */
function RequestOpts() { }
if (false) {
    /** @type {?|undefined} */
    RequestOpts.prototype.cache;
    /** @type {?|undefined} */
    RequestOpts.prototype.requestSerializer;
    /** @type {?|undefined} */
    RequestOpts.prototype.responseSerializer;
    /** @type {?|undefined} */
    RequestOpts.prototype.serializer;
    /** @type {?|undefined} */
    RequestOpts.prototype.serializerKwargs;
    /** @type {?|undefined} */
    RequestOpts.prototype.suppressTimeoutErrors;
    /** @type {?|undefined} */
    RequestOpts.prototype.timeout;
    /** @type {?|undefined} */
    RequestOpts.prototype.transform;
}
/**
 * @record
 */
function DeleteOpts() { }
if (false) {
    /** @type {?|undefined} */
    DeleteOpts.prototype.serializer;
    /** @type {?|undefined} */
    DeleteOpts.prototype.data;
    /** @type {?|undefined} */
    DeleteOpts.prototype.headers;
    /** @type {?|undefined} */
    DeleteOpts.prototype.noTransform;
    /** @type {?|undefined} */
    DeleteOpts.prototype.timeout;
}
/**
 * Use the default browser standard encoding.
 * See: https://github.com/angular/angular/issues/18261#issuecomment-338354119
 */
var /**
 * Use the default browser standard encoding.
 * See: https://github.com/angular/angular/issues/18261#issuecomment-338354119
 */
BrowserEncoder = /** @class */ (function () {
    function BrowserEncoder() {
    }
    /**
     * @param {?} key
     * @return {?}
     */
    BrowserEncoder.prototype.encodeKey = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return encodeURIComponent(key);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    BrowserEncoder.prototype.encodeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return encodeURIComponent(value);
    };
    /**
     * @param {?} key
     * @return {?}
     */
    BrowserEncoder.prototype.decodeKey = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return decodeURIComponent(key);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    BrowserEncoder.prototype.decodeValue = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return decodeURIComponent(value);
    };
    return BrowserEncoder;
}());
/**
 * Parse a raw JavaScript object of request parameters, and return an Angular
 * URLSearchParams instance.
 *
 * \@example - Only parameters provided
 * _parseParams({params: {myKey: 1}});
 * >>> HttpParams({my_key: 1})
 *  / - Pass a paramsSerializer to customize serialization of fields
 * _parseParams({params: {dateField: Moment()}, paramsSerializer: serializer});
 * >>> HttpParams({date_field: '2016-01-01'})
 *  / - Set noTransform to avoid any parameter transformations
 * _parseParams({params: {myKey: 1}, noTransform: true});
 * >>> HttpParams({myKey: 1})
 * @param {?} opts
 * @return {?}
 */
function parseParams(opts) {
    var noTransform = opts.noTransform, paramsSerializer = opts.paramsSerializer;
    /** @type {?} */
    var parsedParams = new HttpParams({ encoder: new BrowserEncoder() });
    var params = opts.params;
    if (params) {
        if (!noTransform) {
            /** @type {?} */
            var paramSerializer = paramsSerializer || serializers.serializer;
            params = paramSerializer.serialize(params);
        }
        Object.keys(params).forEach((/**
         * @param {?} key
         * @return {?}
         */
        function (key) {
            if (params[key] !== undefined && params[key] !== null) {
                /** @type {?} */
                var value = params[key];
                if (Array.isArray(value)) {
                    value.forEach((/**
                     * @param {?} v
                     * @return {?}
                     */
                    function (v) {
                        parsedParams = parsedParams.append(key, v);
                    }));
                }
                else {
                    parsedParams = parsedParams.set(key, params[key]);
                }
            }
        }));
    }
    return parsedParams;
}
export { parseParams };
